export const ABOUT_US_CONSTANTS = {
  TITLE: 'About BC Experience',
  SUBTITLE: 'A Transparent, Real-Time View Into BeautifulCode Teams',
  SECTIONS: {
    WHAT_IS: {
      TITLE: 'What is BC Experience?',
      CONTENT: [
        'BC Experience is a lightweight, web-based platform built by BeautifulCode LLP to help clients gain real-time visibility into how their remote engineering teams are progressing every day.',
        'It captures short "check-ins" that engineers post twice a day—once mid-day, and once at the end of their work session. These updates are instantly reflected on a live dashboard, offering a close-to-in-office view of what\'s happening: what was completed, what\'s in progress, and where help might be needed.',
        'BC Experience is designed to strengthen trust, accountability, and communication between distributed teams and their clients—without micromanagement.',
      ],
    },
    VISION: {
      TITLE: 'Our Vision',
      CONTENT: [
        'At BeautifulCode, we believe great software is built on trust, transparency, and continuous feedback. With BC Experience, we aim to recreate the benefits of in-office collaboration—remotely.',
        'Our vision is to:',
      ],
      BULLET_POINTS: [
        'Reduce miscommunication by keeping all stakeholders on the same page',
        'Identify project risks early through real-time visibility',
        'Standardize service quality across engineering teams',
        'Reinforce accountability and client trust with open, continuous updates',
      ],
      CONCLUSION:
        'BC Experience allows clients to see progress, not just reports—creating an ongoing loop of clarity and alignment.',
    },
    BENEFITS: {
      TITLE: 'Benefits for Clients',
      BULLET_POINTS: [
        'Get updates on what engineers are working on—without having to ask',
        'Quickly spot delays, blockers, or misalignments',
        'Understand time spent across meetings, development, and planning',
        'Gain confidence that your team is focused and aligned with your goals',
      ],
    },
    CALENDAR_ACCESS: {
      TITLE: 'Why We Ask for Google Calendar Read-Only Access',
      CONTENT: [
        'BC Experience can optionally connect to your Google Calendar to give a more complete view of how time is spent across meetings and work sessions.',
        'When you choose to link your calendar, we request read-only access using the following scope:',
      ],
      SCOPE: 'https://www.googleapis.com/auth/calendar.readonly',
      USES: [
        'Understand meeting patterns and time spent on projects',
        'Add helpful context to your check-in updates',
        'Show clients a clear picture of team activity—including meetings, updates, and discussions',
      ],
      DISCLAIMER: [
        'We never edit or share your calendar data. Access is fully optional, and you can disconnect it anytime.',
        'We ask for this scope instead of a more limited one (like free/busy) because we need event titles and durations to provide meaningful insights.',
      ],
    },
    PRIVACY: {
      TITLE: 'Data Privacy & Security',
      CONTENT: ["We take privacy seriously. Here's how we handle user data:"],
      BULLET_POINTS: [
        'Calendar data is read-only, and only accessed after explicit user consent',
        'We do not share calendar data with third parties',
        'Access can be revoked at any time from your Google Account settings',
        'We use Microsoft Clarity for analytics to improve usability; no personally identifiable information is collected',
      ],
    },
  },
  LINKS: {
    PRIVACY_POLICY: 'https://www.beautifulcode.co/privacy-policy',
  },
  STYLES: {
    COLORS: {
      PRIMARY: '#CE3F4F',
      PRIMARY_HOVER: '#b83a48',
      BACKGROUND: '#FDFAF8',
    },
  },
} as const;
